import { APP_INITIALIZER, inject, InjectionToken, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { LocationService } from '@core/location-required/location-required.service';

export const LOCATION_READY = new InjectionToken<Promise<void>>('LOCATION_READY');

export function initLocation(_LocationService: LocationService, router: Router) {
    return async () => {
        try {
            await _LocationService.requestLocation();
        } catch {
            console.log('Location access denied. Redirecting to location required page.');

            router.navigate(['/location-required']);
        }
    };
}
// use this for async initialization without blocking app startup
export const LOCATION_INITIALIZER: Provider[] = [
    {
        provide: LOCATION_READY,
        useFactory: (loc: LocationService, router: Router) => {
            loc.requestLocation().catch(() => router.navigate(['/location-required']));
            return Promise.resolve();
        },
        deps: [LocationService, Router],
    }
];

// use this for blocking app initialization until location is resolved
// export const LOCATION_INITIALIZER: Provider[] = [
//     {
//         provide: APP_INITIALIZER,
//         useFactory: () => initLocation(inject(LocationService), inject(Router)),
//         multi: true
//     },
//     {
//         provide: LOCATION_READY,
//         useFactory: () => initLocation(inject(LocationService), inject(Router))(),
//     }
// ];
